import { Injectable, signal, provideAppInitializer, inject } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { filter, pairwise, startWith } from 'rxjs/operators'
import { EMPTY } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class NavigationService {
	private historySignal = signal<string[]>([])
	private readonly router = inject(Router)

	constructor() {
		this.router.events
			.pipe(
				filter(e => e instanceof NavigationEnd),
				startWith(null),
				pairwise()
			)
			.subscribe(([prev, curr]) => {
				if (!prev) return
				if (!curr) return
				const prevPath = this.getPath(prev.urlAfterRedirects)
				const currPath = this.getPath(curr.urlAfterRedirects)
				if (prevPath !== currPath) {
					this.historySignal.update(h => [...h, prev.urlAfterRedirects])
				}
			})
	}

	private getPath(url: string): string {
		return url.split('?')[0]
	}

	public back(): void {
		const stack = this.historySignal()
		const updated = [...stack]
		const previousUrl = updated.pop()
		this.historySignal.set(updated)
		if (!previousUrl) {
			window.history.back()
			return
		}
		// void this.router.navigateByUrl(previousUrl ?? '/')
		void this.router.navigateByUrl(previousUrl)
	}
}

function initialize(navigationService: NavigationService) {
	return () => EMPTY
}

export const initializeNavigationService = provideAppInitializer(() => {
	return initialize(inject(NavigationService))()
})
